import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import { ArticlesList } from "../../../models/top-articles-for-home-page-model";
import sliderImg from "../../../assets/images/slider/congress.jpg";
import React from "react";

type CardCarouselType = {
  title?: string;
  link?: string;
  page?: string;
  articles: ArticlesList[][];
  includeSubscribe: boolean;
};

const CardCarousel = (props: CardCarouselType) => {
  const { link, title, page, articles, includeSubscribe } = props;
  return (
    <>
      <div className="row mb-2">
        {title !== undefined && link !== undefined && (
          <div className="col-lg-8 col-md-6 col-sm-7 col-xs-12">
            <h2 className="titlecolor">
              <Link to='/news-and-articles'>{title} »</Link>
            </h2>
          </div>
        )}
        {includeSubscribe && (
          <div className="col-lg-4 col-md-6 col-sm-5 col-xs-12 text-right">
            <a href="/preferences" className="more-off btn btn-sm btn-default">
              <span className="titlecolor">Subscribe</span>
            </a>
          </div>
        )}
        <div className="clear"></div>
      </div>

      <Carousel fade controls={false} className="mb-5">
        {articles.map((article) => {
          return article.map((item, index) => {
            return (
              <Carousel.Item key={index}>
                <div className="single-item box-shadow-off box-border margin-bottom-30 margon-top-risk rfitem-0" aria-hidden="false">
                  {item.articleTeaserImage !== "" && (
                    <div className="re-thumb-regfocus">
                      <img src={item.articleTeaserImage} alt={item.articleName} />
                    </div>
                  )}
                  {page !== undefined && page === "profile" ? (
                    <>
                      <h4>
                        <Link to={item.articleUrl}>{item.articleName}</Link>
                      </h4>
                      <h6 className="focus-auth-meta">
                        <span className="span-extra0">{item.articleReleaseDate} |</span>
                        <span className="span-extra1">
                          {" "}
                          By <span className="span-extra2">
                            <a href="">
                                {item.author}
                            </a>
                          </span>
                        </span>
                      </h6>
                      <p className="small lineheightreduced margintop">{item.articleTeaserText}</p>
                      <Link to={item.articleUrl} className="btn btn-more"></Link>
                    </>
                  ) : (
                    <>
                      <h6 className="focus-auth-meta">
                        <span className="span-extra0">{item.articleReleaseDate} |</span>
                        <span className="span-extra1">
                          {" "}
                          By <span className="span-extra2" dangerouslySetInnerHTML={{ __html: item.author }}></span>
                        </span>
                      </h6>
                      <div className="clear margin-bottom-reg"></div>
                      <h6>
                        <Link to={item.articleUrl}>{item.articleName}</Link>
                      </h6>
                      <p className="small lineheightreduced margintop">{item.articleTeaserText}</p>
                      <Link to={item.articleUrl} className="btn btn-more"></Link>
                    </>
                  )}
                </div>
              </Carousel.Item>
            );
          });
        })}
      </Carousel>
    </>
  );
};

export default CardCarousel;
